import * as z from 'zod';

export const createInvitationSchema = z.object({
  email: z.string()
    .email({ message: "Invalid email address" }),
  role: z.enum(['admin', 'provider'], {
    required_error: "Role is required",
    invalid_type_error: "Role must be either 'admin' or 'provider'",
  }),
  shift_type: z.enum(['days_only', 'nights_only', 'both'], {
    required_error: "Shift type is required",
    invalid_type_error: "Shift type must be 'days_only', 'nights_only', or 'both'",
  })
});

export const bulkCreateInvitationSchema = z.object({
  emails: z.string()
    .min(1, { message: "Email addresses are required" })
    .refine(
      (val) => {
        const emails = val.split(/[\s,;]+/).filter(Boolean);
        return emails.every(email => z.string().email().safeParse(email).success);
      },
      { message: "One or more emails are invalid" }
    ),
  role: z.enum(['admin', 'provider'], {
    required_error: "Role is required",
    invalid_type_error: "Role must be either 'admin' or 'provider'",
  }),
  shift_type: z.enum(['days_only', 'nights_only', 'both'], {
    required_error: "Shift type is required",
    invalid_type_error: "Shift type must be 'days_only', 'nights_only', or 'both'",
  })
});

export type CreateInvitationFormValues = z.infer<typeof createInvitationSchema>;
export type BulkCreateInvitationFormValues = z.infer<typeof bulkCreateInvitationSchema>; 